// language=GraphQL
export const ALL_PARTNERS_QUERY = `query Query($withLogo: Boolean = false, $withGtcPdf: Boolean = false) {
  partners: travelPartners {
    id
    name
    url
    logo @include(if: $withLogo) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    logoWidth
    gtcPdf @include(if: $withGtcPdf) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_PARTNER_QUERY = `query Query($id: ID!, $withLogo: Boolean = false, $withGtcPdf: Boolean = false) {
  partner: travelPartner(id: $id) {
    id
    name
    url
    logo @include(if: $withLogo) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    logoWidth
    gtcPdf @include(if: $withGtcPdf) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_PARTNER_MUTATION = `
  mutation Mutation($input: CreateTravelPartnerInput, $withLogo: Boolean = false, $withGtcPdf: Boolean = false) {
    partner: createTravelPartner(input: $input) {
      id
      name
      url
      logo @include(if: $withLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
      gtcPdf @include(if: $withGtcPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_PARTNER_MUTATION = `
  mutation Mutation($input: UpdateTravelPartnerInput, $withLogo: Boolean = false, $withGtcPdf: Boolean = false) {
    partner: updateTravelPartner(input: $input) {
      id
      name
      url
      logo @include(if: $withLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
      gtcPdf @include(if: $withGtcPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_PARTNER_MUTATION = `
  mutation Mutation($input: DeleteTravelPartnerInput) {
    deleteTravelPartner(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PARTNER_MUTATION = `
  mutation Mutation($input: DeleteTravelPartnerInput) {
    forceDeleteTravelPartner(input: $input) {
      success
    }
  }`
// language=GraphQL
export const PARTNERS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false, $withTravels: Boolean = false) {
  groupedDependents: travelPartnerDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`
